import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logger } from 'shared/utils/logger';
import { FormalizedZip, FormalizedZipListItem, FormalizedZipsStateType } from '../types/types';
import {
  getAllFormalizedZips,
  getFormalizedZipById,
  createFormalizedZip,
  updateFormalizedZip,
  deleteFormalizedZip,
  filterFormalizedZips,
} from '../actions/actions';

const initialState: FormalizedZipsStateType = {
  formalizedZips: [],
  formalizedZipDetail: {
    isLoading: false,
    data: null,
  },
  isLoading: false,
};

const slice = createSlice({
  name: 'formalizedZip',
  initialState,
  reducers: {
    dropDetailData(state: FormalizedZipsStateType) {
      state.formalizedZipDetail.data = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllFormalizedZips.pending, (state: FormalizedZipsStateType) => {
      state.isLoading = true;
    });
    builder.addCase(getAllFormalizedZips.fulfilled, (state: FormalizedZipsStateType, action: PayloadAction<FormalizedZipListItem[]>) => {
      state.formalizedZips = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getAllFormalizedZips.rejected, (state: FormalizedZipsStateType, action) => {
      logger.error('formalizedZip/getAllFormalizedZips', action.payload);
      state.isLoading = false;
    });

    builder.addCase(filterFormalizedZips.pending, (state: FormalizedZipsStateType) => {
      state.isLoading = true;
    });
    builder.addCase(filterFormalizedZips.fulfilled, (state: FormalizedZipsStateType, action: PayloadAction<FormalizedZipListItem[]>) => {
      state.formalizedZips = action.payload;
      state.isLoading = false;
    });
    builder.addCase(filterFormalizedZips.rejected, (state: FormalizedZipsStateType, action) => {
      logger.error('formalizedZip/filterFormalizedZips', action.payload);
      state.isLoading = false;
    });

    builder.addCase(getFormalizedZipById.pending, (state: FormalizedZipsStateType) => {
      state.formalizedZipDetail.isLoading = true;
    });
    builder.addCase(getFormalizedZipById.fulfilled, (state: FormalizedZipsStateType, action: PayloadAction<FormalizedZip>) => {
      state.formalizedZipDetail.data = action.payload;
      state.formalizedZipDetail.isLoading = false;
    });
    builder.addCase(getFormalizedZipById.rejected, (state: FormalizedZipsStateType, action) => {
      logger.error('formalizedZip/getFormalizedZipById', action.payload);
      state.formalizedZipDetail.isLoading = false;
    });

    builder.addCase(createFormalizedZip.pending, (state: FormalizedZipsStateType) => {
      state.formalizedZipDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(createFormalizedZip.fulfilled, (state: FormalizedZipsStateType) => {
      state.formalizedZipDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(createFormalizedZip.rejected, (state: FormalizedZipsStateType, action) => {
      logger.error('formalizedZip/createFormalizedZip', action.payload);
      state.formalizedZipDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(updateFormalizedZip.pending, (state: FormalizedZipsStateType) => {
      state.formalizedZipDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(updateFormalizedZip.fulfilled, (state: FormalizedZipsStateType) => {
      state.formalizedZipDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(updateFormalizedZip.rejected, (state: FormalizedZipsStateType, action) => {
      logger.error('formalizedZip/updateFormalizedZip', action.payload);
      state.formalizedZipDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(deleteFormalizedZip.pending, (state: FormalizedZipsStateType) => {
      state.isLoading = true;
    });
    builder.addCase(deleteFormalizedZip.fulfilled, (state: FormalizedZipsStateType, action: PayloadAction<number>) => {
      state.formalizedZips = state.formalizedZips.filter((item) => item.id !== action.payload);
      state.isLoading = false;
    });
    builder.addCase(deleteFormalizedZip.rejected, (state: FormalizedZipsStateType, action) => {
      logger.error('formalizedZip/deleteFormalizedZip', action.payload);
      state.isLoading = false;
    });
  },
});

export const formalizedZipActions = slice.actions;
export default slice.reducer;
